export const DELIVERY_AREA_VISIBILITY_NAME = 'deliveryArea';

export interface DeliveryAreaImpression {
  event: 'custom_event';
  event_action: 'Impression';
  event_category: 'Delivery & Returns';
  event_label: 'not set';
}

export interface DeliveryAreaToggle {
  event: 'custom_event';
  event_action: 'Collapse' | 'Expand';
  event_category: 'Delivery & Returns';
  event_label: 'not set';
}

export interface DeliveryAreaReturnsPolicy {
  event: 'custom_event';
  event_action: 'Returns policy click';
  event_category: 'Delivery & Returns';
  event_label: 'not set';
}
